import './Testimonial.css'

const Testimonial = () =>{
    return (
        <>
        <div className="testimonial-container">
            <div className="testimonial-section">
            </div>
        </div>

        </>
    );
}

export default Testimonial;